import * as types from './actionTypes'

export const invokeRedirect = ({ url, timeout }) => {
  return {
    type: types.INVOKE_REDIRECT,
    payload: {
      url,
      timeout
    }
  }
}

export const relogin = (timeout) => {
  return {
    type: types.RE_LOGIN,
    payload: {
      timeout
    }
  }
}

export const setAlerts = (alerts) => {
  return {
    type: types.SET_ALERTS,
    payload: {
      alerts
    }
  }
}

export const createAlert = ({ type, message, description }) => {
  return {
    type: types.CREATE_ALERT,
    payload: {
      type,
      message,
      description
    }
  }
}

export const dismissAlert = (alertId) => {
  return {
    type: types.DISMISS_ALERT,
    payload: { alertId }
  }
}

export const dismissLastAlert = () => {
  return {
    type: types.DISMISS_LAST_ALERT
  }
}

export const setCrumb = (crumb) => {
  return {
    type: types.SET_CRUMB,
    payload: { crumb }
  }
}

export const setPageInfo = (pageInfo) => {
  return {
    type: types.SET_PAGE_INFO,
    payload: { pageInfo }
  }
}

export const setUser = (user) => {
  return {
    type: types.SET_USER,
    payload: { user }
  }
}

export const setLoading = (loading) => {
  return {
    type: types.SET_LOADING,
    payload: { loading }
  }
}

export const setErrorBox = (errorBox) => {
  return {
    type: types.SET_ERROR_BOX,
    payload: { errorBox }
  }
}

export const switchErrorBox = (active) => {
  return {
    type: types.SWITCH_ERROR_BOX,
    payload: { active }
  }
}

export const setToast = (toast) => {
  return {
    type: types.SET_TOAST,
    payload: { toast }
  }
}

export const switchToast = (active) => {
  return {
    type: types.SWITCH_TOAST,
    payload: { active }
  }
}

export const setNavigationPages = (navigationPages) => {
  return {
    type: types.SET_NAVIGATION_PAGES,
    payload: { navigationPages }
  }
}

export const setI13nData = (i13nData) => {
  return {
    type: types.SET_I13NDATA,
    payload: { i13nData }
  }
}

export const setErrorBoundaryError = (errorBoundaryError, debugError) => {
  return {
    type: types.SET_ERROR_BOUNDARY_ERROR,
    payload: { errorBoundaryError, debugError }
  }
}

export const setPageUserTypeByCookie = pageUserTypeByCookie => {
  const {
    isSeller = false,
    isSupplier = false
  } = pageUserTypeByCookie
  return {
    type: types.SET_PAGE_USER_TYPE_BY_COOKIE,
    payload: { isSeller, isSupplier }
  }
}
